import React from 'react';
import ServicesUploading from './../../../assets/images/placeholder/ServicesUploading-ilustration.png';
import {setComplete} from '../../../actions/user-api';
import { useDispatch, useSelector } from 'react-redux';

export const EmptyState = () => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();

    return (
        <article className="block flex-column h-100">
            <h3 className="sr-only visually-hidden">Finished setup</h3>
            <div className="container container-screen text-center my-auto px-xl-5">
                <img className="img-fluid mx-auto mb-3 mt-4" src={ServicesUploading} alt="Services Uploading" />
                <div className="h2 font-weight-semi mb-4">Félicitations! Votre dossier est complet.</div>
            </div>
            <div className="container container-screen text-center mt-auto">
                <button type="button" className="btn btn-info" onClick={()=>{
                    dispatch(setComplete(user.user));
                }}>Accéder à votre synthèse</button>
            </div>

        </article>
    )
}